import { render, staticRenderFns } from "./_blog-article-overview-highlight-article.vue?vue&type=template&id=32891833"
import script from "./_blog-article-overview-highlight-article.vue?vue&type=script&lang=ts"
export * from "./_blog-article-overview-highlight-article.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports